/**
 * "Size orders as" (was "Trade segment") — the budget that sizes an UNDERLYING order.
 * Mirrors backend services/sizingInstrument.ts effectiveSegment(): an explicit EQUITY /
 * FUTURES wins; anything else (empty, or the retired OPTIONS / CRYPTO) is Auto —
 * FUTURES on a derivatives venue or a futures contract, EQUITY otherwise.
 */
const DERIV_EXCHANGES = ['DELTA', 'NFO', 'BFO', 'MCX', 'CDS', 'BCD', 'NCO'];

export type SizeAs = 'EQUITY' | 'FUTURES';

export function effectiveSegment(exchange: string | null | undefined, instrumentType: string | null | undefined, raw: string | null | undefined): SizeAs {
  const s = String(raw || '').toUpperCase();
  if (s === 'EQUITY' || s === 'FUTURES') return s;
  const ex = String(exchange || '').toUpperCase();
  const it = String(instrumentType || '').toUpperCase();
  return DERIV_EXCHANGES.indexOf(ex) >= 0 || it.indexOf('FUT') >= 0 ? 'FUTURES' : 'EQUITY';
}

/** True when the stored value is Auto (empty / retired). */
export const isAutoSegment = (raw: string | null | undefined) => {
  const s = String(raw || '').toUpperCase();
  return s !== 'EQUITY' && s !== 'FUTURES';
};

export const SIZE_AS_LABEL: Record<SizeAs, string> = { EQUITY: 'Equity', FUTURES: 'Futures' };
